import { render, staticRenderFns } from "./RecurringPayrollContribution.vue?vue&type=template&id=3cefc680"
import script from "./RecurringPayrollContribution.vue?vue&type=script&lang=ts"
export * from "./RecurringPayrollContribution.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports